<template>
	<div class="footer-nav">
		<div class="o-container footer-nav__inner">
			<div class="o-grid o-grid--no-vgutter js-accordion">
				<div class="o-grid__item o-1/4@tablet">
					<div class="footer-nav__first-col">
						<a
							:href="logoLink"
							class="footer-nav__text-logo"
						>footb<span class="footer-nav__alter-color">all</span></a>
					</div>
				</div>

				<accordion
					class="o-grid__item o-1/4@tablet footer-nav__menu"
					v-for="(column, index) in content"
					contentClass="footer-nav__content"
					:key="index"
				>
					<h4 class="footer-nav__header" slot="trigger">
						{{ column.title }}
						<i class="chevron chevron--bottom footer-nav__chevron"></i>
					</h4>

					<ul class="footer-nav__list" slot="content">
						<li
							v-for="item in column.content"
						><a :href="item.link" class="footer-nav__link">{{ item.title }}</a></li>
					</ul>
				</accordion>

			</div>
		</div>
		<div class="o-container">
			<div class="footer-nav__bottom-block">
				<div class="footer-nav__policy-wrap">
					<a :href="privacy.link" class="footer-nav__policy">{{ privacy.text }}</a>
					<span
						v-if="privacy && legal"
						class="footer-nav__divider"
					>|</span>
					<a
						v-if="legal"
						:href="legal.link"
						class="footer-nav__policy"
					>{{ legal.text }}</a>
				</div>
				<span class="footer-nav__rights">{{ rights.text }}</span>
			</div>
		</div>
	</div>
</template>

<script>
	import Accordion from '../animations/Accordion.vue';

	export default {
		components: {
			Accordion
		},
		data() {
			return {
				logoLink: 'https://www.myfootball.com.au/',
				privacy: {
					link: 'https://www.footballaustralia.com.au/privacy',
					text: 'Football Australia Privacy Policy'
				},
				legal: {
					link: 'https://www.ffa.com.au/legal',
					text: 'Legal Notice'
				},
				rights: {
					text: '© 2021 Football Australia ABN 28 106 478 068 | All Rights Reserved'
				},
				content: [{
					title: 'Around the football network',
					content: [{
						title: 'My Football',
						link: 'https://www.myfootball.com.au/'
					}, {
						title: 'Play Football',
						link: 'https://www.playfootball.com.au/'
					}, {
						title: 'Football Australia',
						link: 'https://www.footballaustralia.com.au'
					}, {
						title: 'MiniRoos',
						link: 'https://www.playfootball.com.au/miniroos'
					}]
				}, {
					title: 'Competitions & National teams',
					content: [{
						title: 'Australia Cup',
						link: 'https://www.australiacup.com.au'
					}, {
						title: 'National Premier League',
						link: 'https://www.nationalpremierleagues.com.au'
					}, {
						title: 'Socceroos',
						link: 'https://www.socceroos.com.au'
					}, {
						title: 'Commonwealth Bank Matildas',
						link: 'https://matildas.footballaustralia.com.au'
					}, {
						title: 'Pararoos',
						link: 'https://www.pararoos.com.au'
					}]
				}]
			};
		}
	};
	
</script>

<style lang="scss" scoped>
	@import "~sass/_config.scss";
	@import "~sass/_variables.scss";
	@import "~sass/mixins/_media-query.scss";

	.footer-nav {
		$b: &;
		$gutter: 25px;
		$gridGutter: 16px;

		padding: 70px 0 0;
		background-color: $col-neutral--8;

		/* grid */
		.o-grid {
			margin-left: -$gridGutter;
			margin-bottom: -$gridGutter;
			font-size: 1rem;

			&__item {
				padding-left: $gridGutter;
				margin-bottom: $gridGutter;
				font-size: 1rem;
				display: block;
			}

			&--no-vgutter {
				margin-bottom: 0;

				.o-grid__item {
					margin-bottom: 0;
				}
			}
		}
		/* END grid */

		&__inner {
			padding: 0;
		}

		&__first-col {
			padding: 0 $gutter $gutter;
		}

		&__menu {
			&:nth-child(2) {
				#{$b}__header {
					border-top: 1px solid $col-neutral--9;
				}
			}

			&.is-opened {
				#{$b}__chevron {
					transform: rotateX(180deg);
				}
			}
		}

		&__header {
			font-size: 14px;
			line-height: 30px;
			font-weight: 600;
			text-transform: uppercase;
			background-color: $col-neutral--8;
			color: $col-neutral--6;
			padding: 8px $gutter 12px;
			border-bottom: 1px solid $col-neutral--9;
			display: flex;
			align-items: center;
		}

		&__chevron {
			margin-left: auto;
			transition: transform 500ms;
		}

		&__list {
			list-style: none;
			padding: 13px 0 27px $gutter;
			border-bottom: 1px solid $col-neutral--9;
			width: 100%;
			margin-bottom: -14px;
		}

		&__link {
			display: block;
			color: $col-neutral--6;
			text-decoration: none;
			transition-duration: $ttime;
			margin-bottom: 14px;

			&:hover {
				color: $col-neutral--0;
			}
		}

		// ===
		// network footer only
		// ===

		&__text-logo {
			align-self: flex-start;
			font-size: 19px;
			line-height: 24px;
			font-weight: 800;
			text-transform: uppercase;
			color: $col-t--2;
			text-decoration: none;
		}

		&__alter-color {
			color: $col-neutral--0;
		}

		&__bottom-block {
			padding-top: $gutter;
			padding-bottom: ($gutter * 4/5);
		}

		&__policy-wrap {
			display: flex;
			justify-content: center;
			margin-right: auto;
		}

		&__policy,
		&__rights,
		&__divider {
			display: block;
			color: $col-neutral--6;
			text-align: center;
			font-size: 10px;
			line-height: 12px;
		}

		&__policy {
			text-decoration: none;
			transition-property: color;
			transition-duration: $ttime;

			&:hover {
				color: $col-neutral--0;
			}
		}

		&__divider {
			margin: 0 5px;
		}

		&__address,
		&__address p {
			color: $col-neutral--6;
			font-size: 16px;
			line-height: 1.2;
			margin-bottom: 1em;
		}

		@include mq(mobile) {
			&__first-col {
				display: flex;
				justify-content: space-between;
				padding-bottom: 30px;
			}
		}

		@include mq(tablet) {
			min-height: 0;

			&__inner {
				padding-left: $gutter;
				padding-right: $gutter;
			}

			&__first-col {
				flex-direction: column;
				padding: 0;
			}

			&__menu {
				padding-bottom: 0 !important;
				&:nth-child(2) {
					#{$b}__header {
						border-top: none;
					}
				}
			}

			&__header {
				border-bottom: 2px solid $col-neutral--6;
				margin-bottom: 15px;
				padding: 0;
			}

			&__chevron {
				display: none;
			}

			&__list {
				border-bottom: none;
				padding: 0;
			}

			&__link,
			&__address {
				font-size: 15px;
			}

			// ===
			// network footer only
			// ===
			&__bottom-block {
				display: flex;
				margin-top: 40px;
				border-top: 1px solid rgba($col-neutral--6, 0.2);
				padding-top: 12px;
				padding-bottom: $gutter;
			}
		}

		@include mq(largeTablet) {
			&__link,
			&__address {
				font-size: 1rem;
			}
		}
	}
</style>

<style lang="scss">
	@import "~sass/_config.scss";
	@import "~sass/_variables.scss";
	@import "~sass/mixins/_media-query.scss";

	.footer-nav {
		@include mq(tablet) {
			&__content {
				position: static !important;
			}
		}
	}
</style>
